import "fast-levenshtein";
import "fuzzy";
import { i as Z, m as R } from "./references-BRMYEcTr.js";
import { useState as at, useMemo as lt } from "react";
import { getDefaultStore as q, atom as dt, useAtomValue as tt, useAtom as ft } from "jotai";
import "jotai-effect";
import { jsx as j, Fragment as N } from "react/jsx-runtime";
function ce(t, e = Z) {
  const n = at(() => Xt(R(t), e))[0];
  return lt(
    () => [
      n,
      (o) => {
        const i = R(o, Zt(n));
        qt(n, i);
      }
    ],
    [n]
  );
}
const I = {};
function et(t) {
  return "init" in t;
}
function V(t) {
  return !!t.write;
}
function U(t) {
  return "v" in t || "e" in t;
}
function C(t) {
  if ("e" in t)
    throw t.e;
  if ((I ? "production" : void 0) !== "production" && !("v" in t))
    throw new Error("[Bug] atom state is not initialized");
  return t.v;
}
const D = /* @__PURE__ */ new WeakMap();
function nt(t) {
  var e;
  return L(t) && !!((e = D.get(t)) != null && e[0]);
}
function mt(t) {
  const e = D.get(t);
  e?.[0] && (e[0] = !1, e[1].forEach((n) => n()));
}
function vt(t, e) {
  let n = D.get(t);
  if (!n) {
    n = [!0, /* @__PURE__ */ new Set()], D.set(t, n);
    const o = () => {
      n[0] = !1;
    };
    t.then(o, o);
  }
  n[1].add(e);
}
function L(t) {
  return typeof t?.then == "function";
}
function ot(t, e, n) {
  if (!n.p.has(t)) {
    n.p.add(t);
    const o = () => n.p.delete(t);
    e.then(o, o);
  }
}
function it(t, e, n) {
  var o;
  const i = /* @__PURE__ */ new Set();
  for (const s of ((o = n.get(t)) == null ? void 0 : o.t) || [])
    n.has(s) && i.add(s);
  for (const s of e.p)
    i.add(s);
  return i;
}
const ht = (t, e, ...n) => e.read(...n), pt = (t, e, ...n) => e.write(...n), bt = (t, e) => {
  var n;
  return (n = e.unstable_onInit) == null ? void 0 : n.call(e, t);
}, wt = (t, e, n) => {
  var o;
  return (o = e.onMount) == null ? void 0 : o.call(e, n);
}, gt = (t, e) => {
  const n = A(t), o = n[0], i = n[9];
  if ((I ? "production" : void 0) !== "production" && !e)
    throw new Error("Atom is undefined or null");
  let s = o.get(e);
  return s || (s = { d: /* @__PURE__ */ new Map(), p: /* @__PURE__ */ new Set(), n: 0 }, o.set(e, s), i?.(t, e)), s;
}, yt = (t) => {
  const e = A(t), n = e[1], o = e[3], i = e[4], s = e[5], r = e[6], c = e[13], u = [], a = (l) => {
    try {
      l();
    } catch (d) {
      u.push(d);
    }
  };
  do {
    r.f && a(r.f);
    const l = /* @__PURE__ */ new Set(), d = l.add.bind(l);
    o.forEach((m) => {
      var f;
      return (f = n.get(m)) == null ? void 0 : f.l.forEach(d);
    }), o.clear(), s.forEach(d), s.clear(), i.forEach(d), i.clear(), l.forEach(a), o.size && c(t);
  } while (o.size || s.size || i.size);
  if (u.length)
    throw new AggregateError(u);
}, St = (t) => {
  const e = A(t), n = e[1], o = e[2], i = e[3], s = e[11], r = e[14], c = e[17], u = [], a = /* @__PURE__ */ new WeakSet(), l = /* @__PURE__ */ new WeakSet(), d = Array.from(i);
  for (; d.length; ) {
    const m = d[d.length - 1], f = s(t, m);
    if (l.has(m)) {
      d.pop();
      continue;
    }
    if (a.has(m)) {
      if (o.get(m) === f.n)
        u.push([m, f]);
      else if ((I ? "production" : void 0) !== "production" && o.has(m))
        throw new Error("[Bug] invalidated atom exists");
      l.add(m), d.pop();
      continue;
    }
    a.add(m);
    for (const h of it(m, f, n))
      a.has(h) || d.push(h);
  }
  for (let m = u.length - 1; m >= 0; --m) {
    const [f, h] = u[m];
    let b = !1;
    for (const v of h.d.keys())
      if (v !== f && i.has(v)) {
        b = !0;
        break;
      }
    b && (r(t, f), c(t, f)), o.delete(f);
  }
}, At = (t, e) => {
  var n, o;
  const i = A(t), s = i[1], r = i[2], c = i[3], u = i[6], a = i[7], l = i[11], d = i[12], m = i[13], f = i[14], h = i[16], b = i[17], v = l(t, e);
  if (U(v) && (s.has(e) && r.get(e) !== v.n || Array.from(v.d).every(
    ([p, O]) => (
      // Recursively, read the atom state of the dependency, and
      // check if the atom epoch number is unchanged
      f(t, p).n === O
    )
  )))
    return v;
  v.d.clear();
  let k = !0;
  function y() {
    s.has(e) && (b(t, e), m(t), d(t));
  }
  function M(p) {
    var O;
    if (p === e) {
      const J = l(t, p);
      if (!U(J))
        if (et(p))
          x(t, p, p.init);
        else
          throw new Error("no atom init");
      return C(J);
    }
    const T = f(t, p);
    try {
      return C(T);
    } finally {
      v.d.set(p, T.n), nt(v.v) && ot(e, v.v, T), (O = s.get(p)) == null || O.t.add(e), k || y();
    }
  }
  let S, g;
  const E = {
    get signal() {
      return S || (S = new AbortController()), S.signal;
    },
    get setSelf() {
      return (I ? "production" : void 0) !== "production" && !V(e) && console.warn("setSelf function cannot be used with read-only atom"), !g && V(e) && (g = (...p) => {
        if ((I ? "production" : void 0) !== "production" && k && console.warn("setSelf function cannot be called in sync"), !k)
          try {
            return h(t, e, ...p);
          } finally {
            m(t), d(t);
          }
      }), g;
    }
  }, W = v.n;
  try {
    const p = a(t, e, M, E);
    return x(t, e, p), L(p) && (vt(p, () => S?.abort()), p.then(y, y)), (n = u.r) == null || n.call(u, e), v;
  } catch (p) {
    return delete v.v, v.e = p, ++v.n, v;
  } finally {
    k = !1, W !== v.n && r.get(e) === W && (r.set(e, v.n), c.add(e), (o = u.c) == null || o.call(u, e));
  }
}, kt = (t, e) => {
  const n = A(t), o = n[1], i = n[2], s = n[11], r = [e];
  for (; r.length; ) {
    const c = r.pop(), u = s(t, c);
    for (const a of it(c, u, o)) {
      const l = s(t, a);
      i.set(a, l.n), r.push(a);
    }
  }
}, st = (t, e, ...n) => {
  const o = A(t), i = o[3], s = o[6], r = o[8], c = o[11], u = o[12], a = o[13], l = o[14], d = o[15], m = o[17];
  let f = !0;
  const h = (v) => C(l(t, v)), b = (v, ...k) => {
    var y;
    const M = c(t, v);
    try {
      if (v === e) {
        if (!et(v))
          throw new Error("atom not writable");
        const S = M.n, g = k[0];
        x(t, v, g), m(t, v), S !== M.n && (i.add(v), (y = s.c) == null || y.call(s, v), d(t, v));
        return;
      } else
        return st(t, v, ...k);
    } finally {
      f || (a(t), u(t));
    }
  };
  try {
    return r(t, e, h, b, ...n);
  } finally {
    f = !1;
  }
}, _t = (t, e) => {
  var n;
  const o = A(t), i = o[1], s = o[3], r = o[6], c = o[11], u = o[15], a = o[18], l = o[19], d = c(t, e), m = i.get(e);
  if (m && !nt(d.v)) {
    for (const [f, h] of d.d)
      if (!m.d.has(f)) {
        const b = c(t, f);
        a(t, f).t.add(e), m.d.add(f), h !== b.n && (s.add(f), (n = r.c) == null || n.call(r, f), u(t, f));
      }
    for (const f of m.d || [])
      if (!d.d.has(f)) {
        m.d.delete(f);
        const h = l(t, f);
        h?.t.delete(e);
      }
  }
}, rt = (t, e) => {
  var n;
  const o = A(t), i = o[1], s = o[4], r = o[6], c = o[10], u = o[11], a = o[12], l = o[13], d = o[14], m = o[16], f = u(t, e);
  let h = i.get(e);
  if (!h) {
    d(t, e);
    for (const b of f.d.keys())
      rt(t, b).t.add(e);
    if (h = {
      l: /* @__PURE__ */ new Set(),
      d: new Set(f.d.keys()),
      t: /* @__PURE__ */ new Set()
    }, i.set(e, h), (n = r.m) == null || n.call(r, e), V(e)) {
      const b = () => {
        let v = !0;
        const k = (...y) => {
          try {
            return m(t, e, ...y);
          } finally {
            v || (l(t), a(t));
          }
        };
        try {
          const y = c(t, e, k);
          y && (h.u = () => {
            v = !0;
            try {
              y();
            } finally {
              v = !1;
            }
          });
        } finally {
          v = !1;
        }
      };
      s.add(b);
    }
  }
  return h;
}, Mt = (t, e) => {
  var n;
  const o = A(t), i = o[1], s = o[5], r = o[6], c = o[11], u = o[19], a = c(t, e);
  let l = i.get(e);
  if (l && !l.l.size && !Array.from(l.t).some((d) => {
    var m;
    return (m = i.get(d)) == null ? void 0 : m.d.has(e);
  })) {
    l.u && s.add(l.u), l = void 0, i.delete(e), (n = r.u) == null || n.call(r, e);
    for (const d of a.d.keys()) {
      const m = u(t, d);
      m?.t.delete(e);
    }
    return;
  }
  return l;
}, x = (t, e, n) => {
  const o = A(t)[11], i = o(t, e), s = "v" in i, r = i.v;
  if (L(n))
    for (const c of i.d.keys())
      ot(
        e,
        n,
        o(t, c)
      );
  i.v = n, delete i.e, (!s || !Object.is(r, i.v)) && (++i.n, L(r) && mt(r));
}, Et = (t, e) => {
  const n = A(t)[14];
  return C(n(t, e));
}, Ot = (t, e, ...n) => {
  const o = A(t), i = o[12], s = o[13], r = o[16];
  try {
    return r(t, e, ...n);
  } finally {
    s(t), i(t);
  }
}, Wt = (t, e, n) => {
  const o = A(t), i = o[12], s = o[18], r = o[19], u = s(t, e).l;
  return u.add(n), i(t), () => {
    u.delete(n), r(t, e), i(t);
  };
}, ct = /* @__PURE__ */ new WeakMap(), A = (t) => {
  const e = ct.get(t);
  if ((I ? "production" : void 0) !== "production" && !e)
    throw new Error(
      "Store must be created by buildStore to read its building blocks"
    );
  return e;
};
function It(...t) {
  const e = {
    get(o) {
      const i = A(e)[21];
      return i(e, o);
    },
    set(o, ...i) {
      const s = A(e)[22];
      return s(e, o, ...i);
    },
    sub(o, i) {
      const s = A(e)[23];
      return s(e, o, i);
    }
  }, n = [
    // store state
    /* @__PURE__ */ new WeakMap(),
    // atomStateMap
    /* @__PURE__ */ new WeakMap(),
    // mountedMap
    /* @__PURE__ */ new WeakMap(),
    // invalidatedAtoms
    /* @__PURE__ */ new Set(),
    // changedAtoms
    /* @__PURE__ */ new Set(),
    // mountCallbacks
    /* @__PURE__ */ new Set(),
    // unmountCallbacks
    {},
    // storeHooks
    // atom interceptors
    ht,
    pt,
    bt,
    wt,
    // building-block functions
    gt,
    yt,
    St,
    At,
    kt,
    st,
    _t,
    rt,
    Mt,
    x,
    Et,
    Ot,
    Wt,
    void 0
  ].map((o, i) => t[i] || o);
  return ct.set(e, Object.freeze(n)), e;
}
const ut = {};
let Pt = 0;
function w(t, e) {
  const n = `atom${++Pt}`, o = {
    toString() {
      return (ut ? "production" : void 0) !== "production" && this.debugLabel ? n + ":" + this.debugLabel : n;
    }
  };
  return typeof t == "function" ? o.read = t : (o.init = t, o.read = Rt, o.write = Ct), e && (o.write = e), o;
}
function Rt(t) {
  return t(this);
}
function Ct(t, e, n) {
  return e(
    this,
    typeof n == "function" ? n(t(this)) : n
  );
}
function Dt() {
  return It();
}
let P;
function ue() {
  return P || (P = Dt(), (ut ? "production" : void 0) !== "production" && (globalThis.__JOTAI_DEFAULT_STORE__ || (globalThis.__JOTAI_DEFAULT_STORE__ = P), globalThis.__JOTAI_DEFAULT_STORE__ !== P && console.warn(
    "Detected multiple Jotai instances. It may cause unexpected behavior with the default store. https://github.com/pmndrs/jotai/discussions/2044"
  ))), P;
}
const _ = {}, F = /* @__PURE__ */ Symbol(
  (_ ? "production" : void 0) !== "production" ? "RESET" : ""
);
function ae(t) {
  const e = w(
    t,
    (n, o, i) => {
      const s = typeof i == "function" ? i(n(e)) : i;
      o(e, s === F ? t : s);
    }
  );
  return e;
}
function Lt(t, e) {
  return w(t, function(n, o, i) {
    o(this, e(n(this), i));
  });
}
function le(t, e) {
  let n = null;
  const o = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Set(), s = (c) => {
    let u;
    if (e === void 0)
      u = o.get(c);
    else
      for (const [l, d] of o)
        if (e(l, c)) {
          u = d;
          break;
        }
    if (u !== void 0)
      if (n?.(u[1], c))
        s.remove(c);
      else
        return u[0];
    const a = t(c);
    return o.set(c, [a, Date.now()]), r("CREATE", c, a), a;
  }, r = (c, u, a) => {
    for (const l of i)
      l({ type: c, param: u, atom: a });
  };
  return s.unstable_listen = (c) => (i.add(c), () => {
    i.delete(c);
  }), s.getParams = () => o.keys(), s.remove = (c) => {
    if (e === void 0) {
      if (!o.has(c)) return;
      const [u] = o.get(c);
      o.delete(c), r("REMOVE", c, u);
    } else
      for (const [u, [a]] of o)
        if (e(u, c)) {
          o.delete(u), r("REMOVE", u, a);
          break;
        }
  }, s.setShouldRemove = (c) => {
    if (n = c, !!n)
      for (const [u, [a, l]] of o)
        n(l, u) && (o.delete(u), r("REMOVE", u, a));
  }, s;
}
const B = (t, e, n) => (e.has(n) ? e : e.set(n, t())).get(n), xt = /* @__PURE__ */ new WeakMap(), Tt = (t, e, n, o) => {
  const i = B(() => /* @__PURE__ */ new WeakMap(), xt, e), s = B(() => /* @__PURE__ */ new WeakMap(), i, n);
  return B(t, s, o);
};
function de(t, e, n = Object.is) {
  return Tt(
    () => {
      const o = /* @__PURE__ */ Symbol(), i = ([r, c]) => {
        if (c === o)
          return e(r);
        const u = e(r, c);
        return n(c, u) ? c : u;
      }, s = w((r) => {
        const c = r(s), u = r(t);
        return i([u, c]);
      });
      return s.init = o, s;
    },
    t,
    e,
    n
  );
}
const G = /* @__PURE__ */ new WeakSet(), $ = (t) => {
  if (typeof t != "object" || t === null)
    return t;
  Object.freeze(t);
  const e = Object.getOwnPropertyNames(t);
  for (const n of e)
    $(t[n]);
  return t;
};
function Bt(t) {
  if (G.has(t))
    return t;
  G.add(t);
  const e = t.read;
  if (t.read = function(n, o) {
    return $(e.call(this, n, o));
  }, "write" in t) {
    const n = t.write;
    t.write = function(o, i, ...s) {
      return n.call(
        this,
        o,
        (...r) => (r[0] === t && (r[1] = $(r[1])), i(...r)),
        ...s
      );
    };
  }
  return t;
}
function fe(t) {
  return (_ ? "production" : void 0) !== "production" && console.warn(
    "[DEPRECATED] freezeAtomCreator is deprecated, define it on users end"
  ), ((...e) => Bt(t(...e)));
}
const K = (t, e, n) => (e.has(n) ? e : e.set(n, t())).get(n), zt = /* @__PURE__ */ new WeakMap(), Vt = (t, e, n) => {
  const o = K(() => /* @__PURE__ */ new WeakMap(), zt, e);
  return K(t, o, n);
}, $t = {}, Y = (t) => !!t.write, jt = (t) => typeof t == "function";
function me(t, e) {
  return Vt(
    () => {
      const n = /* @__PURE__ */ new WeakMap(), o = (r, c) => {
        let u = n.get(r);
        if (u)
          return u;
        const a = c && n.get(c), l = [], d = [];
        return r.forEach((m, f) => {
          const h = e ? e(m) : f;
          d[f] = h;
          const b = a && a.atomList[a.keyList.indexOf(h)];
          if (b) {
            l[f] = b;
            return;
          }
          const v = (y) => {
            const M = y(i), S = y(t), E = o(S, M?.arr).keyList.indexOf(h);
            if (E < 0 || E >= S.length) {
              const W = r[o(r).keyList.indexOf(h)];
              if (W)
                return W;
              throw new Error("splitAtom: index out of bounds for read");
            }
            return S[E];
          }, k = (y, M, S) => {
            const g = y(i), E = y(t), p = o(E, g?.arr).keyList.indexOf(h);
            if (p < 0 || p >= E.length)
              throw new Error("splitAtom: index out of bounds for write");
            const O = jt(S) ? S(E[p]) : S;
            Object.is(E[p], O) || M(t, [
              ...E.slice(0, p),
              O,
              ...E.slice(p + 1)
            ]);
          };
          l[f] = Y(t) ? w(v, k) : w(v);
        }), a && a.keyList.length === d.length && a.keyList.every((m, f) => m === d[f]) ? u = a : u = { arr: r, atomList: l, keyList: d }, n.set(r, u), u;
      }, i = w((r) => {
        const c = r(i), u = r(t);
        return o(u, c?.arr);
      });
      (_ ? "production" : void 0) !== "production" && (i.debugPrivate = !0), i.init = void 0;
      const s = Y(t) ? w(
        (r) => r(i).atomList,
        (r, c, u) => {
          switch (u.type) {
            case "remove": {
              const a = r(s).indexOf(u.atom);
              if (a >= 0) {
                const l = r(t);
                c(t, [
                  ...l.slice(0, a),
                  ...l.slice(a + 1)
                ]);
              }
              break;
            }
            case "insert": {
              const a = u.before ? r(s).indexOf(u.before) : r(s).length;
              if (a >= 0) {
                const l = r(t);
                c(t, [
                  ...l.slice(0, a),
                  u.value,
                  ...l.slice(a)
                ]);
              }
              break;
            }
            case "move": {
              const a = r(s).indexOf(u.atom), l = u.before ? r(s).indexOf(u.before) : r(s).length;
              if (a >= 0 && l >= 0) {
                const d = r(t);
                a < l ? c(t, [
                  ...d.slice(0, a),
                  ...d.slice(a + 1, l),
                  d[a],
                  ...d.slice(l)
                ]) : c(t, [
                  ...d.slice(0, l),
                  d[a],
                  ...d.slice(l, a),
                  ...d.slice(a + 1)
                ]);
              }
              break;
            }
          }
        }
      ) : w((r) => r(i).atomList);
      return s;
    },
    t,
    e || $t
  );
}
function ve(t) {
  const e = /* @__PURE__ */ Symbol(), n = w(e);
  (_ ? "production" : void 0) !== "production" && (n.debugPrivate = !0);
  const o = w(
    (i, s) => {
      const r = i(n);
      return r !== e ? r : t(i, s);
    },
    (i, s, r) => {
      const c = typeof r == "function" ? r(i(o)) : r;
      s(n, c === F ? e : c);
    }
  );
  return o;
}
const H = (t) => typeof t?.then == "function";
function he(t) {
  return (e) => ({
    ...e,
    getItem: (o, i) => {
      const s = (c) => t(c) ? c : i, r = e.getItem(o, i);
      return H(r) ? r.then(s) : s(r);
    }
  });
}
function Nt(t = () => {
  try {
    return window.localStorage;
  } catch (n) {
    (_ ? "production" : void 0) !== "production" && typeof window < "u" && console.warn(n);
    return;
  }
}, e) {
  var n;
  let o, i;
  const s = {
    getItem: (u, a) => {
      var l, d;
      const m = (h) => {
        if (h = h || "", o !== h) {
          try {
            i = JSON.parse(h, e?.reviver);
          } catch {
            return a;
          }
          o = h;
        }
        return i;
      }, f = (d = (l = t()) == null ? void 0 : l.getItem(u)) != null ? d : null;
      return H(f) ? f.then(m) : m(f);
    },
    setItem: (u, a) => {
      var l;
      return (l = t()) == null ? void 0 : l.setItem(
        u,
        JSON.stringify(a, e?.replacer)
      );
    },
    removeItem: (u) => {
      var a;
      return (a = t()) == null ? void 0 : a.removeItem(u);
    }
  }, r = (u) => (a, l, d) => u(a, (m) => {
    let f;
    try {
      f = JSON.parse(m || "");
    } catch {
      f = d;
    }
    l(f);
  });
  let c;
  try {
    c = (n = t()) == null ? void 0 : n.subscribe;
  } catch {
  }
  return !c && typeof window < "u" && typeof window.addEventListener == "function" && window.Storage && (c = (u, a) => {
    if (!(t() instanceof window.Storage))
      return () => {
      };
    const l = (d) => {
      d.storageArea === t() && d.key === u && a(d.newValue);
    };
    return window.addEventListener("storage", l), () => {
      window.removeEventListener("storage", l);
    };
  }), c && (s.subscribe = r(c)), s;
}
const Ft = Nt();
function pe(t, e, n = Ft, o) {
  const i = o?.getOnInit, s = w(
    i ? n.getItem(t, e) : e
  );
  return (_ ? "production" : void 0) !== "production" && (s.debugPrivate = !0), s.onMount = (c) => {
    c(n.getItem(t, e));
    let u;
    return n.subscribe && (u = n.subscribe(t, c, e)), u;
  }, w(
    (c) => c(s),
    (c, u, a) => {
      const l = typeof a == "function" ? a(c(s)) : a;
      return l === F ? (u(s, e), n.removeItem(t)) : H(l) ? l.then((d) => (u(s, d), n.setItem(t, d))) : (u(s, l), n.setItem(t, l));
    }
  );
}
const Ht = (t) => typeof t?.then == "function";
function be(t, e) {
  const n = (s) => {
    if ("e" in s)
      throw s.e;
    return s.d;
  }, o = w((s) => {
    var r;
    let c = t(s);
    const u = (r = c[Symbol.observable]) == null ? void 0 : r.call(c);
    u && (c = u);
    let a;
    const l = () => new Promise((g) => {
      a = g;
    }), d = e && "initialValue" in e ? {
      d: typeof e.initialValue == "function" ? e.initialValue() : e.initialValue
    } : l();
    let m, f;
    const h = (g) => {
      f = g, a?.(g), m?.(g);
    };
    let b, v;
    const k = () => !m, y = () => {
      b && (b.unsubscribe(), b = void 0);
    }, M = () => {
      b && (clearTimeout(v), b.unsubscribe()), b = c.subscribe({
        next: (g) => h({ d: g }),
        error: (g) => h({ e: g }),
        complete: () => {
        }
      }), k() && e?.unstable_timeout && (v = setTimeout(y, e.unstable_timeout));
    };
    M();
    const S = w(f || d);
    return (_ ? "production" : void 0) !== "production" && (S.debugPrivate = !0), S.onMount = (g) => (m = g, f && g(f), b ? clearTimeout(v) : M(), () => {
      m = void 0, e?.unstable_timeout ? v = setTimeout(y, e.unstable_timeout) : y();
    }), [S, c, l, M, k];
  });
  return (_ ? "production" : void 0) !== "production" && (o.debugPrivate = !0), w(
    (s) => {
      const [r] = s(o), c = s(r);
      return Ht(c) ? c.then(n) : n(c);
    },
    (s, r, c) => {
      const [u, a, l, d, m] = s(o);
      if ("next" in a)
        m() && (r(u, l()), d()), a.next(c);
      else
        throw new Error("observable is not subject");
    }
  );
}
const z = /* @__PURE__ */ new WeakMap(), Jt = (t, e) => (z.has(e) ? z : z.set(e, t())).get(e), Ut = (t) => typeof t?.then == "function", Q = { state: "loading" };
function we(t) {
  return Jt(() => {
    const e = /* @__PURE__ */ new WeakMap(), n = w(0);
    (_ ? "production" : void 0) !== "production" && (n.debugPrivate = !0);
    const o = w(
      (i, { setSelf: s }) => {
        i(n);
        let r;
        try {
          r = i(t);
        } catch (l) {
          return { state: "hasError", error: l };
        }
        if (!Ut(r))
          return { state: "hasData", data: r };
        const c = r, u = e.get(c);
        if (u)
          return u;
        c.then(
          (l) => {
            e.set(c, { state: "hasData", data: l }), s();
          },
          (l) => {
            e.set(c, { state: "hasError", error: l }), s();
          }
        );
        const a = e.get(c);
        return a || (e.set(c, Q), Q);
      },
      (i, s) => {
        s(n, (r) => r + 1);
      }
    );
    return (_ ? "production" : void 0) !== "production" && (o.debugPrivate = !0), w((i) => i(o));
  }, t);
}
const X = (t, e, n) => (e.has(n) ? e : e.set(n, t())).get(n), Gt = /* @__PURE__ */ new WeakMap(), Kt = (t, e, n) => {
  const o = X(() => /* @__PURE__ */ new WeakMap(), Gt, e);
  return X(t, o, n);
}, Yt = (t) => typeof t?.then == "function", Qt = () => {
};
function ge(t, e = Qt) {
  return Kt(
    () => {
      const n = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new WeakMap(), i = w(0);
      (_ ? "production" : void 0) !== "production" && (i.debugPrivate = !0);
      const s = w(
        (r, { setSelf: c }) => {
          r(i);
          let u;
          try {
            u = r(s);
          } catch {
          }
          const a = r(t);
          if (!Yt(a))
            return { v: a };
          if (a !== u?.p && a.then(
            (l) => {
              o.set(a, l), c();
            },
            (l) => {
              n.set(a, l), c();
            }
          ), n.has(a))
            throw n.get(a);
          return o.has(a) ? {
            p: a,
            v: o.get(a)
          } : u && "v" in u ? { p: a, f: e(u.v), v: u.v } : { p: a, f: e() };
        },
        (r, c) => {
          c(i, (u) => u + 1);
        }
      );
      return s.init = void 0, (_ ? "production" : void 0) !== "production" && (s.debugPrivate = !0), w(
        (r) => {
          const c = r(s);
          return "f" in c ? c.f : c.v;
        },
        (r, c, ...u) => c(t, ...u)
      );
    },
    t,
    e
  );
}
function ye(t, e) {
  const n = w(0);
  return (_ ? "production" : void 0) !== "production" && (n.debugPrivate = !0), w(
    (o, i) => (o(n), t(o, i)),
    (o, i, ...s) => {
      if (s.length === 0)
        i(n, (r) => r + 1);
      else {
        if (e)
          return e(o, i, ...s);
        if ((_ ? "production" : void 0) !== "production")
          throw new Error("refresh must be called without arguments");
      }
    }
  );
}
function Se(t) {
  const e = w(void 0);
  return delete e.init, Object.defineProperty(e, "init", {
    get() {
      return t();
    }
  }), e;
}
function Xt(t, e = Z) {
  return Lt(t, (n, o) => {
    const i = R(o, n);
    return e(n, i) ? n : i;
  });
}
function Zt(t) {
  return q().get(t);
}
function qt(t, e) {
  q().set(t, e);
}
function Ae(t, e) {
  return dt(
    (n) => n(t)[e],
    (n, o, i) => {
      const s = n(t);
      o(t, {
        ...s,
        [e]: R(i, s[e])
      });
    }
  );
}
function ke(t) {
  const e = tt(t.atom$);
  return /* @__PURE__ */ j(N, { children: t.children(e) });
}
function _e(t) {
  const e = t.atoms.map(
    (n) => (
      // eslint-disable-next-line react-hooks/rules-of-hooks
      tt(n)
    )
  );
  return /* @__PURE__ */ j(N, { children: t.children(e) });
}
function Me(t) {
  const e = ft(t.atom$);
  return /* @__PURE__ */ j(N, { children: t.children(e) });
}
export {
  F as R,
  ke as W,
  w as a,
  Xt as b,
  Zt as c,
  Ae as d,
  le as e,
  ve as f,
  ue as g,
  Se as h,
  be as i,
  Lt as j,
  ye as k,
  ae as l,
  pe as m,
  Nt as n,
  Bt as o,
  fe as p,
  we as q,
  vt as r,
  de as s,
  me as t,
  ce as u,
  he as v,
  qt as w,
  ge as x,
  _e as y,
  Me as z
};
//# sourceMappingURL=render-island-BMViq2-G.js.map
